<template>
  <n-modal class="page-record-create" :loading="$var('load')" @close="$emit('close')">
    <div class="line">
      <n-card class="info" :loading="$var('load')">
        <template #header>
          <h3>Информация</h3>
        </template>
        <n-items>
          <n-input title="Проект" :value="project.title" text />
        </n-items>
      </n-card>
    </div>
    
    <n-card :loading="$var('load')">
      <template #header>
        <h3>{{ journal.title }}</h3>
      </template>
      <n-items>
        <n-datepicker title="Дата поступления" v-bind="$form.input('publishedAt')" />
        <n-input title="Номер вагона (автомашины)" v-bind="$form.input('carrNumber')" />
        <n-input title="Поставщик" v-bind="$form.input('dealer')" />
        <block-materials :project-id="project.id" @change="change" />
        <n-input title="Сертификат качества (паспорт, сертификат и т.д.)" v-bind="$form.input('certificate')" />
        <n-input title="Вид упаковки" v-bind="$form.input('type')" />
        <n-input title="Масса, партия, номер" v-bind="$form.input('mass')" />
        <n-datepicker inline title="Дата изготовления" v-bind="$form.input('manufactureDate')" />
        <n-input title="Место отбора образца (выборки или пробы)" v-bind="$form.input('takePlace')" />
        <n-datepicker inline title="Дата отбора образца (выборки или пробы)" v-bind="$form.input('takeDate')" />
      </n-items>
    </n-card>
    
    <n-card>
      <n-divide>
        <div></div>
        <n-button color="success" @click="save">Сохранить</n-button>
      </n-divide>
    </n-card>
  </n-modal>
</template>

<script>
import BlockMaterials from '../../records/create/MaterialBlock'
export default {
  name: 'PageRecordCreate',
  components: { BlockMaterials, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      figures: [],
      material: null,
    }
  },
  created() {
    this.$form.init({
      publishedAt: $app.date.now(),
    })
  },
  methods: {
    save() {
      this.$var('load', true)
      const data = {
        record: this.$form.get(),
      }
      $api.journals.records.create(this.project.id, this.journal.name, data).then((response) => {
        this.$emit('reload')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    change({ id, count, title, }) {
      this.$form.set('materialId', id)
      this.$form.set('materialCount', count)
      this.$form.set('materialTitle', title)
    },
  },
}
</script>

<style lang="scss" scoped>
  .page-record-create {
    
    .line {
      display: flex;
      align-items: flex-start;
      
      & > * {
        white-space: normal;
        display: inline-block;
        margin-bottom: 0;
        flex-grow: .4;
        flex-basis: 1px;
      }
      .items {
        margin-left: 0;
        flex-grow: .6;
      }
    }
    
    
    .weather {
      .unit {
        margin: 0 20px 0 5px;
      }
      .temperature {
        margin-left: 20px;
      }
      .temperature, .wind {
        width: 100px;
      }
    }
    
    .add {
      margin-top: 5px;
      font-size: .8em;
      opacity: .7;
      cursor: pointer;
    }
  }
</style>
